const INTERNAL_EMAIL_SUFFIX = '@rossum.ai';

/**
 * Rossum employees, identified by their `@rossum.ai` email. Used to gate
 * internal-only experiments and UI from customer-facing users.
 */
export const isInternalUser = (user: { email?: string }): boolean =>
  !!user.email?.endsWith(INTERNAL_EMAIL_SUFFIX);
